import { render } from "./AuthorRank.vue?vue&type=template&id=f383db7e"
import script from "./AuthorRank.vue?vue&type=script&lang=js"
export * from "./AuthorRank.vue?vue&type=script&lang=js"

import "./AuthorRank.vue?vue&type=style&index=0&id=f383db7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__